import React, { useEffect, useState } from "react";
import { Table, TableContainer, Paper } from "@mui/material";
import { useForm } from "react-hook-form";
import { yesNoNA, yesNoNA2, yesOrNo } from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/data";
import InputWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/components/Button";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { useSelector } from "react-redux";

const CompoundingChecklist = ({ formData, handleTabChange, role,isEmployee }) => {
  const [errorMsg, setErrorMsg] = useState("");
  const { documents } = useSelector((state) => state.formMT);
  // const isEmployee = role === "EMPLOYEE";
  const tenantId = Digit.ULBService.getStateId() || "up";
  const { data: { BPA: { CompoundingData } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["CompoundingData"]);
  const { control, handleSubmit,reset } = useForm({
    defaultValues: formData || {},
  });
  const Modal = useModal();
  const onSubmit = (data) => {
    setErrorMsg("");
    // Check for showError condition
    let hasError = false;
    CompoundingData?.forEach((item) => {
      const selectedValue = data?.compoundingChecklist?.[item.code];
      if (item.showError && item.showError.toLowerCase() === "yes" && selectedValue && selectedValue.toLowerCase() === "yes") {
        hasError = true;
        Modal(
          "Submission not allowed",
          `For "<b>${item.question}</b>", selecting <b>"Yes"</b> is not allowed. Please select the correct value before proceeding.`,
          "error"
        );
      }
    });

    if (hasError) return;

    handleTabChange(3, data);
  };

  useEffect(() => {
    reset({
      ...formData,
      documents: documents?.length ? documents : formData?.documents || [],
      // compoundingDrawingDxf: formData?.compoundingDrawingDxf?.fileStoreId ? formData?.compoundingDrawingDxf : file || { fileStoreId: "", name: "" },
    });
  }, [formData, documents, reset]);

  console.log("CompoundingChecklist formData", formData);
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TableContainer component={Paper} className="table-container">
        <Table stickyHeader className="application-table">
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              <th style={{ width: "70%" }}>Checklist</th>
              <th style={{ width: "30%", textAlign: "center" }}>Yes / No</th>
            </tr>
          </thead>
          <tbody>
            {CompoundingData?.map((item) => (
              <tr key={item.code}>
                <td>{item.question}<span style={{color:"red",marginLeft:"3px",fontWeight:"bold"}}>*</span></td>
                <td style={{ textAlign: "center" }}>
                  {isEmployee ? (
                    <span style={{ fontWeight: "bold" }}>{formData?.compoundingChecklist?.[item.code] || "-"}</span>
                  ) : (
                    <InputWrapper
                      control={control}
                      label=""
                      hasLabel={false}
                      name={`compoundingChecklist.${item.code}`}
                      defaultValue={formData?.compoundingChecklist?.[item.code]}
                      type="radioButton"
                      data={item.code === "disabledAccessNonCompliance" ? yesNoNA2 : yesOrNo}
                      mandatory
                      validation={{
                      required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      {!isEmployee && errorMsg && <div style={{ color: "red", margin: "1rem 0", textAlign: "center" }}>{errorMsg}</div>}
      {!isEmployee && (
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleTabChange(1)}
            />
            <ButtonWrapper 
            variant="contained" 
            color="success" 
            size="medium" 
            label="Save" 
            type="submit" 
            is
            sx={{ backgroundColor: "#157CB3" }} 
            />
          </div>
        </div>
      )}
    </form>
  );
};

export default CompoundingChecklist;
